<form [formGroup]="formGroup" (submit)="save()" class="app-form">
  <mat-form-field class="app-block" appearance="outline">
    <mat-label i18n>Cost</mat-label>
    <input matInput type="number" formControlName="cost">
    <span matSuffix i18n>per {{element.measure_unit | translation:UNITS}}</span>
  </mat-form-field>
  <mat-form-field class="app-block" appearance="outline">
    <mat-label i18n>Installation cost</mat-label>
    <input matInput type="number" formControlName="installation_cost">
  </mat-form-field>

  <button mat-raised-button [disabled]="formGroup.invalid" i18n>OK</button>
</form>
